export default "__VITE_ASSET__BBkWw7m2__"